import { Input } from "@/components/ui/input";

// The backend's bounds; 72 is bcrypt's limit, counted in characters as Pydantic does.
export const MIN_PASSWORD_LENGTH = 8;
export const MAX_PASSWORD_LENGTH = 72;

interface PasswordFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  /** Shown as plain text (the page's show/hide toggle). */
  visible: boolean;
}

/** One new-password input with its label, for the pages that set a password from an email link. */
export function PasswordField({ id, label, value, onChange, visible }: PasswordFieldProps) {
  return (
    <div className="space-y-2">
      <label htmlFor={id} className="text-foreground t-eyebrow">
        {label}
      </label>
      <Input
        id={id}
        type={visible ? "text" : "password"}
        autoComplete="new-password"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required
      />
    </div>
  );
}

/** What is wrong with a new password, checked before an email link is spent on it. */
export function passwordProblem(password: string, confirmation: string): string {
  const length = Array.from(password).length;
  if (length < MIN_PASSWORD_LENGTH || length > MAX_PASSWORD_LENGTH) {
    return `Use ${MIN_PASSWORD_LENGTH} to ${MAX_PASSWORD_LENGTH} characters.`;
  }
  if (password !== confirmation) {
    return "The passwords don't match.";
  }
  return "";
}
